var _excluded = ["color", "className", "element", "title", "description"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { oneOf, oneOfType, func, string, object } from 'prop-types';
import uuid from 'uuid';
import classNames from 'classnames';
import './Logo.scss';
var propTypes = {
  /** The type of element you need. `span`, `a` or `Link` (from react router) are the most common.
   *
   * Example usage with React Router:<br>
   * `<Logo element={Link} to="/somepage" />` */
  element: oneOfType([string, func, object]),

  /** Logo color */
  color: oneOf(['white', 'black', 'red', 'anthracite']),

  /** Accessible title of the svg, e.g: "Ruter Logo" */
  title: string.isRequired,

  /** Accessible description of the svg, e.g: "A vector illustration of the name 'Ruter' followed by the network symbol" */
  description: string,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  element: 'span',
  title: 'Ruter logo'
};
/**
 * The Logo should be used to brand the application.
 */

var Logo = function Logo(_ref) {
  var color = _ref.color,
      className = _ref.className,
      Element = _ref.element,
      title = _ref.title,
      description = _ref.description,
      rest = _objectWithoutProperties(_ref, _excluded);

  var titleId = "rds-logo-title-".concat(uuid.v4());
  var descriptionId = "rds-logo-description-".concat(uuid.v4());
  var componentClassNames = classNames('rds-logo', {
    'rds-logo--black': color === 'black',
    'rds-logo--white': color === 'white',
    'rds-logo--red': color === 'red',
    'rds-logo--anthracite': color === 'anthracite'
  }, className);
  var elementClassNames = classNames('rds-logo__ratio');
  var path = 'M1192.35 98.4l7.65-39.34h-62l11.47-59h-41.3l-11.47 59h-62l11' + '.47-59h-41.32l-11.46 59h-62l-7.53 39.34h62l-11.47 59h-62l-7.' + '64 39.33h62l-11.47 59h41.31l11.47-59h62l-11.48 59h41.32l11.4' + '7-59h62l7.64-39.33h-62l11.47-59zm-114.73 59h-62l11.48-59h61.' + '95zM135.71 255.62l-49.91-102H49.9v102H0V0h100.16c52.06 0 82.' + '94 35.54 82.94 78.26 0 35.91-21.9 58.16-46.67 67.14l57.08 11' + '0.22zM96.94 44.52h-47V112h47c21.89 0 36.25-14 36.25-33.75s-1' + '4.36-33.73-36.25-33.73zM334.66 255.62v-17.24c-12.2 12.92-29.' + '43 19.38-46.67 19.38-18.67 0-33.75-6.1-44.16-16.51-15.08-15.' + '08-19-32.66-19-53.13V68.57h46.67v113.08c0 25.5 16.16 34.11 3' + '0.87 34.11s31.23-8.61 31.23-34.11V68.57h46.67v187.05zM491.2 ' + '255.62c-38.06 0-54.21-26.93-54.21-53.5v-98.28h-19.75V68.3H43' + '7V18.67h46.67V68.3h33v35.54h-33v95.4c0 10.78 5 16.88 16.15 1' + '6.88h16.87v39.5zM594.52 176.63c0 24.05 14.73 41.64 40.93 41.' + '64 20.47 0 30.52-5.74 42.37-17.59l28.36 27.65c-19 19-37.34 2' + '9.43-71.09 29.43-44.15 0-86.52-20.1-86.52-95.85 0-61 33-95.4' + '9 81.5-95.49 52 0 81.49 38.05 81.49 89.39v20.82zm66.78-52.06' + 'c-5-11.13-15.44-19.38-31.23-19.38s-26.21 8.25-31.23 19.38c-2' + '.88 6.83-4 11.85-4.32 20.1h71.09c-.36-8.25-1.44-13.27-4.31-2' + '0.1zM875.27 72.81c-8.57-4.56-17.93-6.39-29.42-6.39-20.1 0-38' + '.05 9.33-47 20.1v-18h-45.62v187.1h46.67V142.88c0-23.69 15.85' + '-33.08 30.16-34.46 17-1.64 26.33 7 26.33 7z';
  /* Create the aria-labelledby text based on what elements are present in svg*/

  var ariaLabelledBy;

  if (title && description) {
    ariaLabelledBy = "".concat(titleId, " ").concat(descriptionId);
  } else if (title) {
    ariaLabelledBy = titleId;
  } else if (description) {
    ariaLabelledBy = descriptionId;
  } else {
    ariaLabelledBy = titleId;
  }

  var svg = /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 258",
    role: "img"
  }, ariaLabelledBy && {
    'aria-labelledby': ariaLabelledBy
  }), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), description && /*#__PURE__*/React.createElement("desc", {
    id: descriptionId
  }, description), /*#__PURE__*/React.createElement("path", {
    d: path
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClassNames
  }, /*#__PURE__*/React.createElement(Element, _extends({
    className: elementClassNames
  }, rest), svg));
};

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;
export default Logo;